export default "__VITE_ASSET__CejSiX5w__"